export const environment = {
	production: false,
	assetBaseUrl: 'https://ui.stage.central.inmotionhosting.com/web-components/',
	centralAppsApiBase: 'https://api.stage.central.inmotionhosting.com',
	centralAppsPathPrefix: '/v1/apps',
	websocketUrl: 'wss://api.stage.central.inmotionhosting.com',
	appsChannel: 'beta' as const,
	uiVariant: 'labs' as const,
	customDomainsEnabled: true,
	maxApps: 1,
	defaultCodebaseKind: 'lovable',
	betaApiBase: 'https://api.stage.central.inmotionhosting.com/v1/beta',
	labsLandingUrl: 'https://labs.stage.inmotionhosting.com',
	signInOptions: ['google'] as string[],
	firebase: {
		apiKey: 'AIzaSyAtrQT0Dq5tHz_vDtGDtvccYaYF6dNlEN4',
		authDomain: 'stage.apps.inmotionhosting.com',
		databaseURL: 'https://boldgrid-8a9f9.firebaseio.com',
		projectId: 'boldgrid-8a9f9',
		storageBucket: 'boldgrid-8a9f9.appspot.com',
		messagingSenderId: '584077191084',
	},
};
